// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"4f4f3363","453":"a8215ef7","589":"c49ec3ea","610":"c253b195"}[chunkId] + ".chunk.js";
};